import React from 'react';
import { GenericRadio } from 'web-ui-components/lib/data/capture';
import { GenericFieldWrapper } from 'web-ui-components/lib/layout/fieldWrappers';
import { Field } from 'react-final-form';
import { Content } from '../../../infrastructure/content';
import { isRequired } from '../../../utils/validation';

const DebitCardQuestion = ({ values }) => (
  <Content>
    {({
      debitCardQuestionLabel,
      globalRadioError,
      debitCardQuestionValue1 = '',
      debitCardQuestionValue2 = ''
    }) => (
      <Field
        name="debitCardQuestion"
        subscription={{ touched: true, error: true }}
        validate={isRequired}
      >
        {({ meta: { touched, error }, input }) => (
          <GenericFieldWrapper
            inputId="debitCardQuestion"
            title={debitCardQuestionLabel}
            validationMessage={touched && !!error ? globalRadioError : ''}
          >
            <GenericRadio.InlineSet
              groupName="debitCardQuestion"
              items={[
                {
                  id: debitCardQuestionValue1,
                  labelText: debitCardQuestionValue1
                },
                {
                  id: debitCardQuestionValue2,
                  labelText: debitCardQuestionValue2
                }
              ]}
              {...input}
              selectedId={values.debitCardQuestion}
            />
          </GenericFieldWrapper>
        )}
      </Field>
    )}
  </Content>
);

export default DebitCardQuestion;
